import {AbstractControl, ValidatorFn} from '@angular/forms';
import {useDefault} from './common';

export const VALID_NAME_FORM_REGEX = '^[a-zA-Z\\\' +./|’-]+$';

export class FormValidatorUtil {
  static checkBothRequired(firstControlName: string, secondControlName: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const firstName = control.get(firstControlName);
      const lastName = control.get(secondControlName);
      const firstNameValue = useDefault(firstName.value, '').trim();
      const lastNameValue = useDefault(lastName.value, '').trim();
      if ( (!!firstNameValue && !lastNameValue) || (!!lastNameValue && !firstNameValue) ) {
        if (!firstNameValue) {
          firstName.markAsDirty();
        }
        if (!lastNameValue) {
          lastName.markAsDirty();
        }
      }
      if (!firstNameValue && !lastNameValue) {
        control.markAsPristine();
        control.markAsUntouched()
      }
      return null;
    };
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/form-validator.util.ts